// extracted by mini-css-extract-plugin
export default {"container_whatsapp":"WhatsappIcon_container_whatsapp__tUbDk","pulo_container":"WhatsappIcon_pulo_container__ARdkF"};